module.exports = __webpack_public_path__ + "img/blue-Group 185.1582d166.svg";